﻿import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

export const SidePanelTitle: FC<{ titleMessageKey?: IntlKey }> = ({
  titleMessageKey = 'secondaryMarket.sidePanel.label.summary',
}) => {
  const { formatMessage } = useIntl();
  return <div className="fw-bold fs-16 mx-1 mb-3">{formatMessage({ id: titleMessageKey })}</div>;
};

SidePanelTitle.displayName = 'SidePanelTitle';

export const SkeletonSidePanelTitle = () => {
  return (
    <div className="m-3">
      <span className="fw-bold fs-16">
        <Skeleton width="8em" />
      </span>
    </div>
  );
};

SkeletonSidePanelTitle.displayName = 'SkeletonSidePanelTitle';
